import { useMemo } from "react";
import { Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import {
  CHART_COLORS,
  ChartSkeleton,
  ListSkeleton,
  Numeric,
  SectionCard,
} from "@/shared/components";
import { useDomainUsage } from "./hooks";

const PIE_COLORS = CHART_COLORS;

export function DomainUsage() {
  const { data: domainUsage, isLoading } = useDomainUsage();

  const totalUsage = (domainUsage ?? []).reduce(
    (sum, item) => sum + item.count,
    0,
  );
  const pieData = useMemo(
    () =>
      (domainUsage ?? []).map((item, i) => ({
        ...item,
        fill: PIE_COLORS[i % PIE_COLORS.length],
      })),
    [domainUsage],
  );

  return (
    <SectionCard title="도메인 사용량">
      {isLoading ? (
        <>
          <ChartSkeleton height={220} />
          <ListSkeleton count={5} className="mt-3" />
        </>
      ) : (
        <>
          <div className="mb-3 text-[12px] text-text-tertiary">
            총 {totalUsage.toLocaleString()}회
          </div>
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie
                data={pieData}
                dataKey="count"
                nameKey="domain"
                outerRadius={80}
              />
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
          <div className="mt-3 space-y-2">
            {pieData.map((item) => (
              <div
                key={item.domain}
                className="flex items-center justify-between text-[12px]"
              >
                <div className="flex items-center gap-2">
                  <span
                    className="size-2 rounded-full"
                    style={{ backgroundColor: item.fill }}
                  />
                  <span>{item.domain}</span>
                </div>
                <Numeric>{item.count}</Numeric>
              </div>
            ))}
          </div>
        </>
      )}
    </SectionCard>
  );
}
